"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppBannerOptionsObject = exports.ToastNotificationSchema = exports.ToastNotificationIconSchema = void 0;
const typebox_1 = require("@sinclair/typebox");
function StringEnum(values) {
    return typebox_1.Type.Unsafe({ type: 'string', enum: values });
}
exports.ToastNotificationIconSchema = StringEnum([
    'default',
    'info',
    'success',
    'attention',
    'warning',
    'error'
]);
exports.ToastNotificationSchema = typebox_1.Type.Object({
    id: typebox_1.Type.Optional(typebox_1.Type.String()),
    category: typebox_1.Type.Strict(exports.ToastNotificationIconSchema),
    message: typebox_1.Type.String(),
    title: typebox_1.Type.Optional(typebox_1.Type.String()),
    cta: typebox_1.Type.Optional(typebox_1.Type.String()),
    icon: typebox_1.Type.Optional(typebox_1.Type.String())
});
exports.AppBannerOptionsObject = typebox_1.Type.Object({
    title: typebox_1.Type.String(),
    author: typebox_1.Type.String(),
    button: typebox_1.Type.String(),
    buttonUrlApple: typebox_1.Type.String(),
    buttonUrlGoogle: typebox_1.Type.String(),
    iconApple: typebox_1.Type.String(),
    iconGoogle: typebox_1.Type.String(),
    price: typebox_1.Type.Optional(typebox_1.Type.String({ default: '' })),
    priceSuffixApple: typebox_1.Type.Optional(typebox_1.Type.String({ default: '' })),
    priceSuffixGoogle: typebox_1.Type.Optional(typebox_1.Type.String({ default: '' }))
});
